import { BannerCarousel } from '@iheartjane/menu';

import { CarouselSkeleton } from '@jane/bloom/components/skeletonLoaders/carouselSkeleton';
import { useIsNavigatingAway } from '@jane/bloom/hooks/navigation/useIsNavigating';
import { usePinStore } from '@jane/bloom/hooks/storeSwitcher/usePinStore';
import type { CarouselBanner } from '@jane/bloom/types/schemas/roots/carouselBanner';

interface BloomCarouselProps {
  items: CarouselBanner;
  storeName?: string;
}

const AUTO_SLIDE_INTERVAL = 7000;

export const BloomCarousel = ({ items, storeName }: BloomCarouselProps) => {
  const { pinning: manuallyPinning } = usePinStore();
  const isNavigatingAway = useIsNavigatingAway();
  const shouldShowSkeleton = manuallyPinning || isNavigatingAway;

  if (shouldShowSkeleton) {
    return <CarouselSkeleton mode="carousel" />;
  }

  const slides = items.map((banner) => ({
    imageAlt: banner.alt_text ?? `${storeName} Marketing Banner`,
    imageSrc: banner.image_url,
    url: banner.url,
  }));

  return <BannerCarousel slides={slides} autoAdvanceMs={AUTO_SLIDE_INTERVAL} />;
};
